<div class="encolumnat">
    <h1 class="titol">{{ 'REGISTERCOMPONENT.YOUR_REGULAR_CARRIER.TITLE' | translate }}</h1>
    <h2 class="texte" [innerHTML]="'REGISTERCOMPONENT.YOUR_REGULAR_CARRIER.SUBTITLE' | translate"></h2>

    <shared-partner-detail [linkType]="'company'" [(formGroup)]="registerFormGroup" [(link)]="registerData.regularCarrier"></shared-partner-detail>
 
    <div class="button-zone">
        <button mat-flat-button color="primary" class="seguent action" (click)="next()" [disabled]="pendigResponse">{{'REGISTERCOMPONENT.NEXTBUTTON.LABEL' | translate}}</button>
    </div>
</div>
